module.exports = __webpack_public_path__ + "static/media/recordings.e2f69165.svg";